import type { RootState } from '@/root-store';

import { namespace } from '../namespace';

export const getIsAppInitialized = (state: RootState) => state[namespace].isAppInitialized;
export const getFatalErrorSlug = (state: RootState) => state[namespace].fatalError;
